const ContactComponentListing = r => require.ensure([], () => r(require('./ContactComponentListing.vue')), 'contactlist-shared')

export default ContactComponentListing
